import React, { useRef } from 'react';
import { FieldProps } from 'formik';
import './styles.css';

const ImagePicker: React.SFC<FieldProps> = ({
  field: { name, value, ...fieldProps },
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  const inputEl = useRef<any|undefined>(undefined);

  const onChangeFile = (e: any) => {
    // touchFieldHandler();
    console.log('onChangeFile');
    if (e.target.value) {
      setFieldValue(name, e.target.files[0]);
    } else {
      e.preventDefault();
    }
  };

  const onClear = (e: any) => {
    setFieldValue(name, undefined);
  }

  const onButtonClick = () => {
    inputEl.current.click();
  }


  return (
    <div className="draggble__zone cart_zone">
      <button onClick={onButtonClick} className="btn btn-secondary" disabled={value ? true : false}>Загрузить фото</button>
      {!value ?
        <div className="zone_for_file"><span>Выберите фото для загрузки</span></div>
      : (
        <div className="zone_for_file">
          <div className="file__">{typeof value === 'string' ? value.split('/').pop() : value.name}
          <svg onClick={onClear} style={{ marginTop: '-14px', cursor: 'pointer' }} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10.5" cy="10.5" r="10.5" fill="#B7BFC7"/><path fillRule="evenodd" clipRule="evenodd" d="M9.43037 10.5L6.22154 13.7088C5.92616 14.0042 5.92616 14.4831 6.22154 14.7784C6.51692 15.0738 6.99577 15.0738 7.29115 14.7784L10.5 11.5695L13.7089 14.7785C14.0043 15.0738 14.4831 15.0738 14.7785 14.7785C15.0738 14.4831 15.0738 14.0042 14.7785 13.7089L11.5696 10.5L14.7785 7.29115C15.0738 6.99577 15.0738 6.51687 14.7785 6.22153C14.4831 5.92615 14.0043 5.92615 13.7089 6.22153L10.5 9.43042L7.29115 6.22153C6.99581 5.92615 6.51691 5.92615 6.22153 6.22153C5.92616 6.51691 5.92616 6.99577 6.22154 7.29115L9.43037 10.5Z" fill="white"/></svg></div>
        </div>
      )}
      {/* <form name="f1"> */}
        <input
          ref={inputEl}
          className="news__fileinput"
          onChange={onChangeFile}
          type="file"
          name="t1"
          id="filedropper"
          style={{ display: 'none' }}
        />
      {/* </form> */}
    </div>
  );
};

export default ImagePicker;
